import {connect} from 'react-redux';
import {size} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {allOrders} from '/redux/action/report.action';
import {
  hasReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {calculatePageNumber} from '/util/requestParams.util';

import {ModalFilter} from './ModalPopoverFilter';

export default connect(
  createStructuredSelector({
    reportIsLoading: reportIsLoadingStateValue,
    hasReportData,
    reportData,
    reportMeta,
  }),
  dispatch => ({
    fetchReport: ({
      reportName,
      reportParams,
      appendData,
      level,
      products,
      accountStatus,
    }: any) => {
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        allOrders({
          reportName,
          reportParams,
          appendData,
          level,
          products,
          accountStatus,
        }),
      );
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchReportData: ({level, products, accountStatus}: any) => {
      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps;
      const {reportIsLoading} = stateProps;
      if (!reportIsLoading) {
        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: 1,
            },
            ...restParams,
          ],
          appendData: false,
          level,
          products,
          accountStatus,
        });
      }
    },
    fetchMoreReport: ({level, products, accountStatus}: any) => {
      const {reportIsLoading, reportMeta} = stateProps;

      const {isEndReached, currentPage = 1} = reportMeta || {};
      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps;

      if (!reportIsLoading && !isEndReached) {
        const numberOfRecords = size(stateProps.reportData);
        const total = reportMeta?.page?.total ?? 0;
        const nextPageNumber = calculatePageNumber({
          numberOfRecords,
          pageSize,
          total,
        });
        if (!nextPageNumber) return;
        if (nextPageNumber <= currentPage) return;

        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: nextPageNumber,
            },
            ...restParams,
          ],
          appendData: true,
          level,
          products,
          accountStatus,
        });
      }
    },
  }),
)(ModalFilter);
